// eslint-disable-next-line spaced-comment
///  <reference types="vite/client" />
import { PostHogProvider } from 'posthog-js/react'
import type React from 'react'
import { getPosthogConfig } from '../telemetry-config.js'

/** Undefined for a local build or without a key, so PostHog never starts (GH #2334) */
const config = getPosthogConfig(import.meta.env)

export const Posthog = ({ children }: { children: React.ReactNode }) => {
  if (!config) {
    return <>{children}</>
  }
  return (
    <PostHogProvider
      apiKey={config.apiKey}
      options={{
        api_host: config.apiHost,
        ui_host: config.uiHost,
      }}
    >
      {children}
    </PostHogProvider>
  )
}
